import Component from "vue-class-component";
import Vue from "vue";
import moduleStore from "../../store/memberDay";
import { getQueryString } from "@/utils/location";
import { Watch, Prop } from "vue-property-decorator";

/**components**/
@Component({
  props: {},
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class Carousel extends Vue {
  self: Vue = this;
  historyList: Array<any> = [];
  userInfo: any = null;
  swiperIndex = 0;
  colorList =['#07C6C2 ','#FF70B1','#9166FF','#3FA0FF','#27DEAF','#F78E44','#7B6DFE','#F1C560'];
  created() {}
  mounted() {
    this.getPurchaseMsgFn();
    window.memberDayPayCallback = this.getAppCallback;
    this.getUserInfo();
  }

  @Watch("$route")
  onActivityType() {
      this.getPurchaseMsgFn(true);
      this.$emit("flushMessage")
  }
  onChange(index) {
    this.swiperIndex=index
  }

  getPurchaseMsgFn(addSelf = false) {
    this.$http("getPurchaseMsg").then((res) => {
      if (res.code === 200) {
        this.historyList = res.data;
        if (addSelf && this.userInfo) {
          this.pushSelfData()
        }
        this.historyList.map((item) => {
          item.bgcolor = this.colorList[Math.floor(Math.random() * this.colorList.length)];
        });
      }
    });
  }
  // app回调
  getAppCallback(res) {
    const Res = JSON.stringify(res);
    const data = JSON.parse(Res)||{};
    this.pushSelfData(data)
    this.$emit("flushMessage")
  }

  pushSelfData(data?) {
    //可能要插入到播放的位置
    const defaultImage =
      "https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-04-14-2848724100232052465.svg";
    const { headerImage, name } = this.userInfo;
    let historyList = this.historyList.slice(this.swiperIndex)
    historyList[2] = {
      headerImage: headerImage || defaultImage,
      name,
      reduce: data?.reduce || getQueryString("reduce") || 0,
    };
    this.historyList = historyList;
  }

  getUserInfo() {
    this.$http("getUser", {
      origin: "voice-maker"
    }).then((res) => {
      if (res.code == 200) {
        this.userInfo = res.data;
      }
    });
  }
}
